/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import Input from '../../atoms/Input/Input';
// componentes
import ClockHelper from '../ClockHelper/ClockHelper';

// assets
import './style.css';

const InputCodeSMS = (props) => {
  const {
    values,
    secondsAvailableToRespond,
    disabled,
    objectMessage,
    onChange,
    onTimeOverToRespond,
    onInvokeAuthSms,
    alignContent,
    id
  } = props;

  const [isTimeOverToRespond, setIsTimeOverToRespond] = useState(false);
  const [currentFocus, setCurrentFocus] = useState(0);

  useEffect(() => {
    /* istanbul ignore next */
    if (!disabled) {
      const firstPositionEmpty = values.indexOf('');
      setCurrentFocus(firstPositionEmpty);
    }
  }, [values]);

  useEffect(() => {
    /* istanbul ignore next */
    if (isTimeOverToRespond && onTimeOverToRespond) onTimeOverToRespond(isTimeOverToRespond);
  }, [isTimeOverToRespond]);

  const handleOnBlur = () => {
    setCurrentFocus(-1); // COMMENT: para que ningun input tenga foco
  };

  const handleChangeCodes = (idx, value) => {
    const tempValues = [...values];
    tempValues[idx] = value;
    onChange(tempValues);
  };

  const handleTimeOver = () => {
    setIsTimeOverToRespond(true);
  };

  const handleRetry = () => {
    setIsTimeOverToRespond(false);
    onInvokeAuthSms();
  };
  /* istanbul ignore next */
  return (
    <section className={id === 2 ? 'InputCodeSMS' : 'InputCodeSMS2'}>
      <form className="InputCodeSMS__form">
        <section
          className={`InputCodeSMS__input-group d-flex ${
            alignContent === 'center' ? 'justify-content-center' : ''
          }`}
        >
          {values.map((val, index) => (
            <div key={shortid.generate()} className="">
              <Input
                name={`inp-sms-${index}`}
                value={val}
                type="number"
                maxLength={1}
                disabled={disabled || isTimeOverToRespond}
                focused={index === currentFocus}
                onBlur={() => handleOnBlur()}
                onChange={(e) => handleChangeCodes(index, e.target.value)}
              />
            </div>
          ))}
        </section>
        <section className="InputCodeSMS__countdown">
          <ClockHelper
            mode="timer"
            initialTime={secondsAvailableToRespond}
            objectMessage={objectMessage}
            onTimeOver={handleTimeOver}
            onRetry={handleRetry}
          />
        </section>
      </form>
    </section>
  );
};
/* istanbul ignore next */
InputCodeSMS.defaultProps = {
  values: [],
  objectMessage: {},
  // errorMessage: '',
  secondsAvailableToRespond: -1,
  disabled: false,
  onChange: () => null,
  onTimeOverToRespond: () => null,
  onInvokeAuthSms: () => null,
};

InputCodeSMS.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  objectMessage: PropTypes.shape({}),
  // errorMessage: PropTypes.string,
  secondsAvailableToRespond: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onTimeOverToRespond: PropTypes.func,
  onInvokeAuthSms: PropTypes.func,
};

export default InputCodeSMS;
